// extracted by css-extract-rspack-plugin
export default {"idWrapper":"ProgramCandidates_idWrapper__JtNGD","idHead":"ProgramCandidates_idHead__6s5Ds","idTail":"ProgramCandidates_idTail__Msi3V"};